/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import WeekoffNtimeShiftPresenter from './WeekoffNtimeshiftPresenter';
import DTOWeekoffNtimeShift from './DTOWeekoffNtimeshift';
import { useTranslation } from 'react-i18next';

function WeekoffNtimeShiftController() {
  const { t } = useTranslation();
  const [WnTData, setWnTData] = useState([]);

  function callBackFunc(data: any) {
    setWnTData(data);
  }
  return (
    <>
      <DTOWeekoffNtimeShift setWeekoffNTimeData={callBackFunc} />
      <WeekoffNtimeShiftPresenter WeekoffNtimeshiftData={WnTData} trans={t} />
    </>
  );
}

export default WeekoffNtimeShiftController;
